import "./WintergartenExtended.css";

export default function WintergartenExtended() {
  return (
    <div className="wg-extended">

      <h1>🌿 Wintergarten einrichten – kreative & realistische Ideen (ausführlich)</h1>

      <p>
        Ein Wintergarten ist weit mehr als nur ein zusätzlicher Raum mit Glasflächen.
        Er verbindet Innen- und Außenwelt und schafft einen Ort voller Licht, Ruhe und Naturgefühl.
      </p>

      <p>
        Durch seine besondere Bauweise verändert sich die Atmosphäre ständig:
        morgens frisch, mittags lebendig, abends ruhig und gemütlich.
      </p>

      <p>
        Ein gut geplanter Wintergarten kann vieles sein – Rückzugsort, Arbeitsplatz,
        Essbereich oder einfach ein Ort zum Abschalten.
      </p>

      <h2>🛋️ Möbel: Komfort, Funktion und Langlebigkeit</h2>

      <p>
        Die Möblierung ist das Herzstück jedes Wintergartens und bestimmt sowohl
        Stil als auch Alltagstauglichkeit.
      </p>

      <h3>🌾 Geeignete Materialien</h3>
      <ul>
        <li>Rattan & Polyrattan – leicht, flexibel und robust</li>
        <li>Holz (Teak, Akazie, Eiche) – warm und natürlich</li>
        <li>Outdoor-Polster – UV-beständig und pflegeleicht</li>
      </ul>

      <h3>🪑 Einrichtungsideen</h3>
      <ul>
        <li>Große Lounge-Ecke</li>
        <li>Kleiner Bistrotisch</li>
        <li>Flexible oder klappbare Möbel</li>
        <li>Sitzbänke mit Stauraum</li>
      </ul>

      <p>
        In kleinen Räumen wirken leichte und schlichte Möbel besser als schwere,
        massive Einrichtungen.
      </p>

      <h2>🌱 Pflanzen: Das Herz des Wintergartens</h2>

      <p>
        Pflanzen sind essenziell für Atmosphäre, Luftqualität und ein natürliches Raumgefühl.
      </p>

      <h3>☀️ Lichtabhängige Pflanzen</h3>
      <ul>
        <li>Sonne: Zitrusbäume, Oleander, Bougainvillea</li>
        <li>Halbschatten: Farne, Calathea, Orchideen</li>
        <li>Große Pflanzen: Palmen, Ficus, Strelitzien</li>
      </ul>

      <h3>🌿 Gestaltungsideen</h3>
      <ul>
        <li>Vertikale Gärten</li>
        <li>Mehrstöckige Pflanzenregale</li>
        <li>Hängende Pflanzen</li>
        <li>Mischung aus kleinen & großen Pflanzen</li>
      </ul>

      <h2>💡 Licht: Atmosphäre für jede Tageszeit</h2>

      <p>
        Licht verändert komplett die Stimmung im Raum, besonders am Abend.
      </p>

      <ul>
        <li>Deckenlampen für Grundlicht</li>
        <li>Spots für Akzente</li>
        <li>Stehlampen für gemütliche Bereiche</li>
        <li>LED-Streifen für indirektes Licht</li>
        <li>Lichterketten für Atmosphäre</li>
      </ul>

      <p>
        Mit Smart-Home oder Dimmern lässt sich die Stimmung jederzeit anpassen.
      </p>

      <h2>🎨 Farben & Textilien</h2>

      <h3>🎨 Farbkonzepte</h3>
      <ul>
        <li>Helle Töne → ruhig & modern</li>
        <li>Grüntöne → natürlich & harmonisch</li>
        <li>Erdtöne → warm & gemütlich</li>
      </ul>

      <h3>🧵 Textilien</h3>
      <ul>
        <li>Kissen & Decken</li>
        <li>Leichte Vorhänge</li>
        <li>Naturteppiche (Jute, Sisal)</li>
      </ul>

      <h2>🏡 Stilrichtungen</h2>

      <ul>
        <li>Skandinavisch – hell & schlicht</li>
        <li>Mediterran – warm & natürlich</li>
        <li>Modern – minimalistisch</li>
        <li>Boho – kreativ & pflanzenreich</li>
        <li>Industrial – roh & urban</li>
        <li>Landhaus – gemütlich & verspielt</li>
      </ul>

      <h2>🧭 Raumaufteilung</h2>

      <ul>
        <li>Leseecke</li>
        <li>Arbeitsbereich</li>
        <li>Essbereich</li>
        <li>Pflanzenzone</li>
      </ul>

      <p>
        Durch Teppiche, Möbel und Pflanzen lassen sich Bereiche klar trennen,
        ohne den offenen Charakter zu verlieren.
      </p>

      <h2>🌟 Fazit</h2>

      <p>
        Ein Wintergarten entsteht durch das Zusammenspiel von Möbeln, Pflanzen,
        Licht und Farben.
      </p>

      <p>
        Wenn alles harmonisch abgestimmt ist, entsteht ein Raum, der das ganze
        Jahr über genutzt werden kann und sich immer gut anfühlt.
      </p>

    </div>
  );
}